import type { ProductKitAsset } from "./types";

export function productKitAssetStatusPresentation(status: ProductKitAsset["analysisStatus"]): { label: string; tone: "ready" | "working" | "failed"; detail: string } {
  if (status === "ready") return { label: "ready", tone: "ready", detail: "Pixel analysis complete and available to ad workflows." };
  if (status === "processing") return { label: "analyzing", tone: "working", detail: "Deterministic pixel analysis is running now." };
  if (status === "queued") return { label: "queued", tone: "working", detail: "Queued for deterministic pixel analysis." };
  return { label: "analysis failed", tone: "failed", detail: "Pixel analysis stopped. Open Operations for the recorded cause and recovery action." };
}
